var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoGraph01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40.8 40.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.8,
    height: 40.8,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 40.8,
    height: 40.8,
    rx: 8,
    ry: 8,
    fill: "#f2642a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.1628,28.7653h4.041V11.7523h-4.041v17.013Zm4.84,1.599h-5.64c-.441,0-.799-.358-.799-.799V10.9533c0-.442.358-.8.799-.8h5.64c.441,0,.799.358.799.8v18.612c0,.441-.358.799-.799.799",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.1628,28.7653h4.041V11.7523h-4.041v17.013Zm4.84,1.599h-5.64c-.441,0-.799-.358-.799-.799V10.9533c0-.442.358-.8.799-.8h5.64c.441,0,.799.358.799.8v18.612c0,.441-.358.799-.799.799Z",
    fill: "none",
    stroke: "#f2642a",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.3711,28.7653h4.041v-7.989h-4.041v7.989Zm4.84,1.599h-5.64c-.441,0-.799-.358-.799-.799v-9.588c0-.442.358-.8.799-.8h5.64c.441,0,.799.358.799.8v9.588c0,.441-.358.799-.799.799",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.3711,28.7653h4.041v-7.989h-4.041v7.989Zm4.84,1.599h-5.64c-.441,0-.799-.358-.799-.799v-9.588c0-.442.358-.8.799-.8h5.64c.441,0,.799.358.799.8v9.588c0,.441-.358.799-.799.799Z",
    fill: "none",
    stroke: "#f2642a",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.2669,28.7653h4.041v-11.937h-4.041v11.937Zm4.84,1.599h-5.64c-.441,0-.799-.358-.799-.799v-13.536c0-.442.358-.8.799-.8h5.64c.441,0,.799.358.799.8v13.536c0,.441-.358.799-.799.799",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.2669,28.7653h4.041v-11.937h-4.041v11.937Zm4.84,1.599h-5.64c-.441,0-.799-.358-.799-.799v-13.536c0-.442.358-.8.799-.8h5.64c.441,0,.799.358.799.8v13.536c0,.441-.358.799-.799.799Z",
    fill: "none",
    stroke: "#f2642a",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.1177,30.6463H7.1747c-.442,0-.8-.358-.8-.799,0-.442.358-.8.8-.8h25.943c.441,0,.799.358.799.8,0,.441-.358.799-.799.799",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.1177,30.6463H7.1747c-.442,0-.8-.358-.8-.799,0-.442.358-.8.8-.8h25.943c.441,0,.799.358.799.8,0,.441-.358.799-.799.799Z",
    fill: "none",
    stroke: "#f2642a",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoGraph01);
export default __webpack_public_path__ + "static/media/ico-graph-01.1811a0d93312c035cdda51c486d683d6.svg";
export { ForwardRef as ReactComponent };